<template>
    <b-modal id="modal-campaign" title="Add Email Content" hide-footer size="lg" centered @hidden="resetForm">
        <validation-observer ref="observer" v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="handleSubmit(validateAndSubmit)">
            <b-row>
                <!-- Campaign Name -->
                <b-col md="6">
                    <b-form-group label="Post Name" label-for="campaign_name">
                        <validation-provider rules="required" #default="{ errors }" name="campaign name"
                            vid="Campaign Name">
                            <b-form-input v-model="campaignName" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Start Date -->
                <b-col md="6">
                    <b-form-group label="Start Date" label-for="start_date">
                        <validation-provider rules="required" #default="{ errors }" name="start date" vid="Start Date">
                            <b-form-datepicker v-model="startDate" id="start_date" placeholder="Choose a date"
                                local="en" :min="currentDate" :state="errors.length > 0 ? false : null" :initial-date="new Date()" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- End Date -->
                <b-col md="6">
                    <b-form-group label="End Date" label-for="end_date">
                        <validation-provider rules="required" #default="{ errors }" name="end date" vid="End Date">
                            <b-form-datepicker v-model="endDate" id="end_date" placeholder="Choose a date" local="en"
                            :min="startDate || currentDate" :state="errors.length > 0 ? false : null" :initial-date="startDate"/>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Email Template -->
                <b-col md="6">
                    <b-form-group label="Template" label-for="email_template">
                        <validation-provider #default="{ errors }" name="email template" vid="Email Template">
                            <b-form-select 
                                v-model="selectedTemplateId"
                                :options="templateOptions"
                                @change="selectTemplate"
                                :state="errors.length > 0 ? false : null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- SMTP Setting -->
                <b-col md="6">
                    <b-form-group label="SMTP Setting" label-for="email_smtp">
                        <validation-provider rules="required" #default="{ errors }" name="SMTP setting"
                            vid="SMTP Setting">
                            <b-form-select v-model="selectedProvider" :state="errors.length > 0 ? false : null"
                                :options="smtp" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Segment -->
                <b-col md="6">
                    <b-form-group label="Segment" label-for="segment">
                        <validation-provider rules="required" #default="{ errors }" name="segment" vid="Segment">
                            <v-select v-model="selectedSegments" :options="segmentOptions" label="itemTitle" multiple
                                :clearable="false" class="item-selector-title" placeholder="Select Item"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Subject -->
                <b-col md="12">
                    <b-form-group label="Subject" label-for="subject">
                        <validation-provider rules="required" #default="{ errors }" name="subject" vid="Subject">
                            <b-form-input v-model="selectedTemplate.subject" placeholder="Subject" name="subject"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Email Content -->
                <b-col md="12">
                    <b-form-group label="Content" label-for="email_content">
                        <validation-provider rules="required" #default="{ errors }" name="email content"
                            vid="Email Content">
                            <quill-editor v-model="selectedTemplate.content" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
                 <!-- Cost Input Field -->
                 <b-col md="12">
                    <b-form-group label="Budget" label-for="cost">
                        <validation-provider rules="required|numeric|min_value:1" #default="{ errors }" name="cost">
                            <b-form-input type="number" v-model="cost" placeholder="Enter Budget" name="cost"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- Submit Button -->
            <b-col md="12" class="d-flex justify-content-end">
                <b-button type="submit" variant="primary">SUBMIT</b-button>
            </b-col>
        </b-form>
      </validation-observer>
    </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormSelect, BFormInput, BFormDatepicker, BButton, BCol, BRow, BFormRadio, } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VSelect from "vue-select";
import { quillEditor } from "vue-quill-editor";
import { mapActions, mapGetters } from "vuex";
import {
  getProviderName,
  createProvider,
  deleteProvider,
  getProviders,
  testsmtp,
  updateProvider,
} from "@/store/smtp/services";

export default {
    components: {
        BModal,
        BForm,
        BFormGroup,
        BFormSelect,
        BFormInput,
        BFormDatepicker,
        BButton,
        BCol,
        BRow,
        ValidationProvider,
        VSelect,
        quillEditor,
        BFormRadio,
        ValidationObserver,
    },
    data() {
        return {
            campaignName: "",
            campaignId: this.$route.params.id,
            platformName: "Email",
            campaignOptions: [],
            startDate: null,
            endDate: null,
            selectedTemplateId: null,
            emailtemplatelist: [],
            selectedProvider: null,
            smtp: [],
            selectedSegments: [],
            segmentOptions: [],
            selectedTemplate: {
                subject: "",
                content: ""
            },
            currentDate: new Date().toISOString().split("T")[0],
            SelectedRadio: "D",
        };
    },

    computed: {
        ...mapGetters("marketingModule", {
            appid: "appid",
            campaignId: "campaignId",
            posts: "drafts",
            eventsTaskslist: "eventtasks",
            loadingMarketing: "loading",
        }),

    ...mapGetters("emailtemplate", {
      emailtemplate: "emailtemplate",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    ...mapGetters("emailcampaign", {
      emailcampaign: "emailcampaign",
      loading: "loading",
    }),
    ...mapGetters("marketingModule", {
      campaigns: "campaigns",
      loading: "loading",
      marketingTemplate: "marketingTemplate"
    }),
    templateOptions() {
        return this.emailtemplatelist.length > 0 
            ? this.emailtemplatelist 
            : [{ value: 0, text: "NO TEMPLATE AVAILABLE", disabled: true }];
    }
  },

    methods: {
        resetForm() {
        this.campaignName = "";
        this.startDate = null;
        this.endDate = null;
        this.selectedTemplateId = null;
        this.selectedProvider = null;
        this.selectedSegments = [];
        this.selectedTemplate = {
            subject: "",
            content: ""
        };
        this.cost = null;
    },
        ...mapActions("marketingModule", [
            "getAppIdAction",
            "getPostAction",
            "removePostAction", "postSocialAction",
            "postMarketingCampaignAction",
            "getMarketingCampaignByIDAction",
            "putMarketingCampaignAction",
            "getCampaignDraftListAction", "postCampaignDraftAction",
            "getEventTaskListAction", "postEventTaskAction", "putEventTaskAction"
        ]),
        ...mapActions("segmentModule", ["getSegmentsAction"]),
        ...mapActions("emailtemplate", ["getEmailTemplateListAction"]),
        ...mapActions("emailcampaign", ["addEmailCampaignAction"]),
        ...mapActions("marketingModule", ["getCampaignsListAction", "getContentTemplateAction"]),

        selectTemplate() {
    console.log("Selected Template ID:", this.selectedTemplateId);

    // Find template from the dropdown list
    const template = this.emailtemplatelist.find(
        (template) => template.value === this.selectedTemplateId
    );

    if (template) {
        console.log("Template Found:", template);

        // Assign template properties
        this.selectedTemplate = { ...template };

            // ✅ Ensure Vue reactivity
        this.$set(this.selectedTemplate, "content", this.selectedTemplate.content || "");
        this.$set(this.selectedTemplate, "subject", this.selectedTemplate.subject || "");

    } else {
        console.warn("Template not found!");
        this.selectedTemplate = { subject: "", content: ""};
    }

    console.log("Final Selected Template:", this.selectedTemplate);
},
    setFormData(item) {
            if (item) {
                this.campaignName = item.name || "";
                this.cost = item.budget || "";
                this.content = item.content || "";

                // Extract link from mediaDetails safely
                let mediaDetails = [];
                try {
                    mediaDetails = JSON.parse(item.mediaDetails || "[]");
                } catch (error) {
                    console.error("Error parsing media details:", error);
                }
                this.link = mediaDetails.length > 0 ? mediaDetails[0].Url.replace(/["]/g, '') : "";
                this.mediaType = mediaDetails.length > 0 ? mediaDetails[0].MediaType : "image";


            }
        },
        submitCampaignForm() {

            let loader = this.$swal({
                title: "Processing...",
                text: "Please wait while the email is being added",
                didOpen: () => {
                    this.$swal.showLoading();
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
                buttonsStyling: false,
                showConfirmButton: false,
            });
             
            const payload = {
                campaignId: this.campaignId,
                name: this.campaignName,
                content: this.selectedTemplate.content,
                startDate: this.startDate,
                endDate: this.endDate,
                smtpSettingId: this.selectedProvider,
                subject: this.selectedTemplate.subject,
                status: "DRAFT",
                platform: "Email",
                budget: this.cost,
                segmentId: this.selectedSegments.map(segment => segment.value),
                
                mediaDetails: [
                    {
                        Path: "",
                        Url: "",
                        MediaType: ""
                    },
                ],
            };
            console.log("payload",payload);
            this.postCampaignDraftAction(payload)
                .then((response) => {
                    loader.close();

                    // Reset the form
                    this.newCost = {
                        campaignId: this.campaignId,
                        category: "",
                        description: "",
                        amount: null,
                        date: "",
                    };

                    // Hide the modal
                    this.$bvModal.hide("modal-campaign");

                    // Show success notification
                    this.$swal("Success", "email added successfully!", "success");
                    this.$emit("content-updated");
                    this.resetForm();
                })
                .catch((error) => {
                    console.error("Error adding cost:", error);
                    loader.close();
                    this.error("Failed to add email. Please try again.");
                });
        },
        async getSMPT() {
      try {
        const response = await getProviders();
        this.smtp = response.data.result.map((smtp) => ({
          value: smtp.id,
          text: `${smtp.provider}`,
        }));
      } catch (error) {
        console.log(error);
      }
    },
    validateAndSubmit() {
        this.submitCampaignForm();
        },
    },
    async mounted() {

    this.mainLoading = true;

    try {
        await this.getContentTemplateAction(this.platformName).then(() => {

        this.emailtemplatelist = this.marketingTemplate.map((template) => ({
            value: template.id,
            text: `${template.name}`,
            content: template.content || "",
            subject: template.subject || "",
        }));

        console.log("Dropdown Data (All Items):", this.emailtemplatelist);
    });
      await this.getSMPT();
      await this.getCampaignsListAction().then(()=>{
        const filteredCampaigns = this.campaigns.filter(campaign => campaign.status === 'COMPLETED');
        this.campaignOptions = filteredCampaigns.map((campaign)=>({
          value:campaign.id,
          text: `${campaign.name}`,
        }));
      
      });
      await this.getSegmentsAction().then(() => {
        this.segmentOptions = this.segments.map((segment) => ({
          value: segment.segmentId,
          itemTitle: `${segment.name}`,
        }));
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.mainLoading = false;
    }
  },

  watch: {
    emailtemplatelist(newValue) {
        console.log("Updated Dropdown Data (All Items):", newValue);
    }
}

};
</script>

<style>
.item-selector-title {
    width: 100%;
}
</style>